<template>
  <pl-dialog
    :size="'lg'"
    title="Welcome to Parlay!!"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div
      class="flex flex-grow items-center justify-center h-full overflow-auto"
    >
      <iframe
        width="80%"
        height="80%"
        :src="'https://www.youtube.com/embed/qPKEiK-Qp7Y'"
      >
      </iframe>
    </div>
    <footer class="flex flex-col items-center justify-center pb-5">
      <button
        @click="$emit('close')"
        class="bg-primary px-5 py-2 rounded text-white text-lg font-semibold"
      >
        Let´s Get Started!
      </button>
      <div class="mt-1">
        <a
          href="https://parlayideas.com/how-it-works/"
          target="_blank"
          class="hover:underline text-xs text-primary"
        >
          How it works
        </a>
        <i
          class="fas fa-external-link-alt text-primary"
          style="font-size: 8px"
        ></i>
      </div>
    </footer>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({});
</script>



// WEBPACK FOOTER //
// ModalAfterSignUp.vue?3d888d2e